export default "__VITE_ASSET__DyXcw7y___"